const viewAny = (permissions) => {
  return permissions.includes('read-resource')
}

const view = (permissions) => {
  return permissions.includes('read-resource')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-resource')
}

const update = (permissions) => {
  return hasPermission(permissions, 'update-resource')
}

const deletee = (permissions) => {
  return hasPermission(permissions, 'delete-resource')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  view,
  create,
  update,
  deletee,
  hasPermission,
};